import { BaseField, BaseFieldModel } from '../baseField';
import { FieldType } from '../fieldType';

export interface AcknowledgmentFieldModel extends BaseFieldModel {
  defaultValue: boolean;
  type: FieldType.Acknowledgment;
}

export class AcknowledgmentField extends BaseField implements AcknowledgmentFieldModel {
  public defaultValue = false;
  public type: FieldType.Acknowledgment = FieldType.Acknowledgment;

  constructor(cultures: string[]) {
    super(FieldType.Acknowledgment, cultures);
  }
}
